module.exports = __webpack_public_path__ + "NanumSquareEB.9b98722f867c623aada9.eot";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareEB.eot
// module id = ../../../../../src/assets/font/NanumSquareEB.eot
// module chunks = styles